import React, { ReactNode } from "react";
import { Box, Chip, Sheet, Stack, Typography } from "@mui/joy";
import { useTheme } from "@mui/joy/styles";

import { getSevaGradientSurface } from "../../theme/branding";

interface PageHeroProps {
  title: string;
  description?: string;
  eyebrow?: string;
  actions?: ReactNode;
}

export default function PageHero({ title, description, eyebrow, actions }: PageHeroProps) {
  const theme = useTheme();
  const gradient = getSevaGradientSurface(theme, { withShadow: true });

  return (
    <Sheet
      sx={{
        ...gradient,
        borderRadius: "xl",
        p: { xs: 3, md: 4 },
        position: "relative",
        overflow: "hidden",
        mb: 4 ,
      }}
    >
      <Box
        sx={{ 
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(80% 100% at 110% 10%, rgba(255,255,255,0.18) 0%, transparent 70%), radial-gradient(60% 60% at -10% 110%, rgba(9,63,155,0.28) 0%, transparent 75%)",
          pointerEvents: "none",
        }}
      />
      <Stack spacing={1.5} sx={{ position: "relative", zIndex: 1 }}>
        {eyebrow ? (
          <Chip size="sm" variant="soft" color="neutral" sx={{ alignSelf: "flex-start", fontWeight: 600 }}>
            {eyebrow}
          </Chip>
        ) : null}
        <Typography level="h2" sx={{ fontWeight: 800, letterSpacing: -0.4, color: "rgba(255,255,255,0.86)" }}>
          {title}
        </Typography>
        {description ? (
          <Typography level="body-md" sx={{ color: "rgba(255,255,255,0.86)", maxWidth: 560 }}>
            {description}
          </Typography>
        ) : null}
        {actions ? (
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ pt: 0.5, color: "rgba(255,255,255,0.86)" }}>
            {actions}
          </Stack>
        ) : null}
      </Stack>
    </Sheet>
  );
}
